import { createLazyReactDirective } from '../shell/createLazyReactDirective';

export default createLazyReactDirective(
  async () => (await import('./AddNoteForm')).AddNoteForm,
  'addNoteForm',
  {
    entityId: '=?',
    entityType: '@?',
    query: '=?',
    onCancel: '&onCancel',
    onSave: '&onSave',
  },
);
